export default __webpack_public_path__ + "static/logo-3d-a482b6c3f67d021acc8cab35876bb0a3.png";